import React from "react";
import { Text } from "@networkraildigitalfactory/components";

const ObjectiveInfo = (props) => {
  const { wrapper, label } = props;
  let { answer } = props;

  if (typeof answer === "string" && answer.includes("\n")) {
    answer = answer.split("\n");
  }
  return (
    <>
      <Text wrapper="span" type="body" color="#000000">
        {label}
      </Text>
      {typeof answer === "string" ? (
        <Text wrapper={wrapper || "p"} type="body" style={{ marginBottom: "1em" }}>
          {answer}
        </Text>
      ) : (
        answer?.map((line, index) => {
          return (
            <Text key={index} wrapper={wrapper || "p"} type="body" style={{ marginBottom: "1em" }}>
              {line}
            </Text>
          );
        })
      )}
    </>
  );
};
export default ObjectiveInfo;
